function getUrlBase64(dataImg, callback) {
  // let self = this
  var baseImg
  // var base64Img = document.createElement('base64Img'),
  var canvas = document.createElement('canvas'),
    context = canvas.getContext('2d')
  // 创建新图片
  var img = new Image()
  img.crossOrigin = 'Anonymous'
  img.src = dataImg
  img.addEventListener(
    'load',
    () => {
      // 绘制图片到canvas上
      canvas.width = img.width
      canvas.height = img.height
      context.drawImage(img, 0, 0)
      // 将canvas的透明背景设置成白色
      var imageData = context.getImageData(0, 0, canvas.width, canvas.height)
      context.putImageData(imageData, 0, 0)
      baseImg = canvas.toDataURL('image/png').slice(22) //返回base64
      if (typeof callback !== undefined) {
        if (callback) callback(baseImg)
      }
    },
    false,
  )
}

export default getUrlBase64
